"use client";

const FullPageLoader = () => {
  return (
    <div className="flex items-center justify-center min-h-screen w-full bg-background">
      <div className="flex flex-col items-center gap-4">
        <div
          className="
            w-12 h-12 
            rounded-full 
            border-4 
            border-neutral-900
            border-t-accent-primary
            animate-spin
          "
        ></div>

        <p className="text-sm text-foreground tracking-wide">Loading...</p>
      </div>
    </div>
  );
};

export default FullPageLoader;
